import React from 'react';
import { Route } from 'react-router';
import { Redirect } from 'react-router-dom';
import { hasCookie } from '../../utils/cookieUtil';
import { store } from '../../index.js';
import _ from 'lodash';

const AuthenticatedRoute = ({ component: Component, ...rest }) => {
  const auth = () => {
    // has already logged in
    if (hasCookie()) {
      return true;
    }

    return null;
  };

  const authRole = (locationUrl) => {
    let response=false;
    const state = store.getState();

    if (state && state.login) {
      const login = state.login.toJS();

      if (!_.isNil(login.menu)) {
        login.menu.forEach(menuItem => {
          if(response==true) 
            return;

          if (!_.isNil(menuItem.subObjects)) {
            menuItem.subObjects.forEach(object => {
              if(object.link===locationUrl){
                response= true;
                return;
              }
            });
          }
        });
      }
    }

    return response;
  };

  return (
    <Route {...rest} render={(props) => (
      auth() === true ?
      authRole(props.location.pathname) === true ?
        <Component {...props} /> 
        :<Redirect to={{
          pathname: '/NotFound',
          state: { from: props.location }
        }}/>
      :<Redirect to={{
        pathname: '/login',
        state: { from: props.location }
      }} />
    )} />
  );
};

export default AuthenticatedRoute;
